import { Provider } from '@types';

export default function formatProviderName(provider: Provider): string {
  const { firstName, lastName } = provider;

  return `${firstName} ${lastName}`;
}
